export default __webpack_public_path__ + "static/06_powerful_platform-b45bedc2704c5ff801b1d268dd216d50.png";